module.exports = __webpack_public_path__ + "VIPH15.png?cc6f398a7a6d786e8d610b6c760ae0b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH15.png
// module id = 87
// module chunks = 0